import { Form, Select } from 'antd';
import { memo, Suspense } from 'react';

import { DynamicListEntity, DynamicListEntityProps } from './dynamic-list-entity';
import { SchemaModelFieldType } from '@smx-ui-model/types';

interface FieldDynamicListEntityProps<T, K, M> extends DynamicListEntityProps<T, K, M>{
    field: SchemaModelFieldType;
}

export const FieldDynamicListEntity = <T, K=any, M=any>
({ field, style, ...restProps }: FieldDynamicListEntityProps<T, K, M>) => {
    const fallback = (
        <>
            {
                <Form.Item label={field.title}>
                    <Select disabled={field.isReadonly} loading={true}  style={style} />
                </Form.Item>
            }
        </>
    );

    const FieldDynamicList = DynamicListEntity<T, K, M>();

    return (
        <Suspense fallback={fallback}>
            {
                <Form.Item name={field.name} label={field.title}>
                    <FieldDynamicList disabled={false} style={style} {...restProps} />
                </Form.Item>
            }
        </Suspense>
    );
};

export default memo(FieldDynamicListEntity);
